import { SeeOnMap } from "../../admin/common/details-components";

const PropertyDetailsHeaderSection = ({
  displayTitle,
  location,
  companyId,
}) => {
  return (
    <div className="mb-4 flex-col flex sm:gap-y-1 md:gap-y-2">
      {/* title */}
      <h2 className="font-medium text-primary-navy tracking-[0.01em] leading-relaxed line-clamp-1 text-lg sm:text-2xl md:text-3xl ">
        {displayTitle}
      </h2>

      <div className="flex flex-row justify-between items-start md:items-center gap-1">
        <SeeOnMap location={location} />

        {companyId && (
          <button
            onClick={() => {
              window.location.href = `/company-details/${companyId}`;
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="text-red-600 self-end hover:text-red-700 transition-colors underline text-[0.7rem] sm:text-sm font-medium flex items-center justify-end tracking-wide"
          >
            View Developer's Details
          </button>
        )}
      </div>
    </div>
  );
};
export default PropertyDetailsHeaderSection;
